<template>
  <div class="input-csat">
    <button
      v-for="option in options"
      :key="option.value"
      class="input-csat__option"
      :class="{ 'input-csat__option--selected': option.isSelected }"
      @click.prevent="selectOption(option)"
    >
      <SvgIconCsatStar/>

      <span>
        {{ option.value }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseInputCsat',

  props: {
    value: {
      type: Array,
      default: []
    }
  },

  data () {
    return {
      options: [
        {
          value: 1,
          isSelected: false
        },
        {
          value: 2,
          isSelected: false
        },
        {
          value: 3,
          isSelected: false,
        },
        {
          value: 4,
          isSelected: false
        },
        {
          value: 5,
          isSelected: false
        }
      ]
    }
  },

  computed: {
    optionsSelected () {
      return this.options
        .filter(option => option.isSelected == true)
        .map(option => option.value)
    }
  },

  mounted () {
    this.fillOptionsDefault()
  },

  methods: {
    selectOption (option) {
      option.isSelected = !option.isSelected

      Object.assign(this.options, option)

      this.$emit('input', this.optionsSelected)
    },

    fillOptionsDefault () {
      this.options = this.options.map(option => {
        if (this.value.includes(option.value)) {
          option.isSelected = true
        }

        return option
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.input-csat {
  $border: 0.7px solid rgba(nth($colors-custom, 1), 0.5);
  $border-radius: 3.6px;

  display: inline-flex;
  border: $border;
  border-radius: $border-radius;

  &__option {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 47px;
    height: 36.5px;
    border: none;
    transition: all 0.1s;
    background: none;

    &:not(:first-child) {
      border-left: $border;
    }

    &:first-child {
      border-radius: $border-radius 0 0 $border-radius;
    }

    &:last-child {
      border-radius: 0 $border-radius $border-radius 0;
    }

    svg {
      width: 19px;
      transition: all 0.1s;
      fill: #e2e4e9;
    }

    span {
      position: absolute;
      bottom: -20px;
      left: 50%;
      opacity: 0;
      transform: translateX(-50%);
      transition: all 0.1s;
      font: {
        weight: 700;
        size: 11px;
      }
    }

    &--selected {
      background: nth($colors-custom, 10);

      svg {
        fill: nth($colors-custom, 1);
      }

      span {
        opacity: 1;
      }
    }
  }
}
</style>
